import { useEnterAction } from '../lib/useEnterAction';
import type { RoundResult } from '../types';
import type { PreparedRound } from '../lib/lessonGenerator';

interface ImageryIntermissionProps {
  round: PreparedRound;
  result: RoundResult;
  isLast: boolean;
  onContinue: () => void;
}

const ROUND_CLOSINGS = [
  'Godt. Samme ord vender tilbage — nu med kortere blink.',
  'Fint. Næste runde: lyt og mærk bevægelsen indeni.',
] as const;

export default function ImageryIntermission({
  round,
  result,
  isLast,
  onContinue,
}: ImageryIntermissionProps) {
  useEnterAction(onContinue);
  const closing =
    round.index < ROUND_CLOSINGS.length
      ? ROUND_CLOSINGS[round.index]
      : 'Rolig pause før næste trin.';

  const calmNote = result.completed
    ? 'Runden er gennemført.'
    : 'Du stoppede før tid — det er også ok.';

  return (
    <div className="mx-auto w-full max-w-xl animate-fade-in-up px-4 py-8 text-center">
      <p className="text-xs font-medium tracking-[0.2em] uppercase text-stone-400 dark:text-stone-500">
        Pause
      </p>
      <h2 className="mt-3 text-xl font-light text-strong">
        {round.template.title}
      </h2>
      <p className="mt-4 text-sm leading-relaxed text-muted">{closing}</p>
      <p className="mt-2 text-xs text-faint">{calmNote}</p>

      <button
        type="button"
        autoFocus
        onClick={onContinue}
        className="mt-8 rounded-full border border-stone-300 bg-stone-50 px-8 py-3 text-sm font-medium text-stone-800 transition hover:bg-stone-100 dark:border-stone-600 dark:bg-stone-800/60 dark:text-stone-100 dark:hover:bg-stone-800"
      >
        {isLast ? 'Afslut øvelsen' : 'Næste runde'}
      </button>
      <p className="mt-2 text-xs text-faint">Enter</p>
    </div>
  );
}
